import Minze, { MinzeElement, EventListeners, Attrs } from 'minze'
import { Locale } from '../../modules/locale'
import { Font } from '../../constants'

Locale.getInstance().registerKeySet('fr', 'verifyExhibitionExistenceModal', {
  title: 'Vérifiez si l’exposition existe déjà sur La Vitrine',
  text: `Vérifiez que toute l'information est à jour en effectuant une recherche sur <a href="https://www.lavitrine.com/fr/recherche/" target="_blank">lavitrine.com/fr/recherche/</a> avant de soumettre une demande.`,
  cancel: 'Annuler',
  submit: 'Continuer',
})

Locale.getInstance().registerKeySet('en', 'verifyExhibitionExistenceModal', {
  title: 'Check if the exhibition already exists on La Vitrine',
  text: `Check that all information is up to date by searching <a href="https://www.lavitrine.com/en/search/" target="_blank">lavitrine.com/en/search/</a> before submitting an application.`,
  cancel: 'Cancel',
  submit: 'Continue',
})

export interface LvcVerifyExhibitionExistenceModal {}

export class LvcVerifyExhibitionExistenceModal extends MinzeElement {
  html = () => {
    return `
    <lvc-closeable-modal max-width="512px" no-close-button="true">
      <h3 class="title">
        ${Locale.getKey('verifyExhibitionExistenceModal.title')}
      </h3>
      <p class="text">
        ${Locale.getKey('verifyExhibitionExistenceModal.text')}
      </p>
      <div class="buttons">
        <lvc-button
          border="1px solid #1E007D"
          padding="14px 24px"
          theme="transparent"
          width="100%"
          class="button"
          id="cancel-button"
          type="submit"
        >
          ${Locale.getKey('verifyExhibitionExistenceModal.cancel')}
        </lvc-button>
        <lvc-button
          padding="14px 24px"
          bg="#1E007D"
          border="1px solid #1E007D"
          width="100%"
          class="button"
          id="confirm-button"
          type="submit"
        >
          ${Locale.getKey('verifyExhibitionExistenceModal.submit')}
        </lvc-button>
      </div>
    </lvc-closeable-modal>
    `
  }

  css = () => `
    .title {
      font-weight: ${Font.weight.extraBold};
      font-size: 24px;
      line-height: 120%;
      color: #1E007D;
      text-transform: uppercase;
      margin: 0;
      text-align: center;
    }
    
    .text {
      font-weight: ${Font.weight.medium};
      font-size: 17px;
      line-height: 24px;
      color: #1E007D;
      margin: 40px 0;
    }
    
    .text a {
      color: #1E007D;
    }
    
    .buttons {
      margin-top: 40px;
      display: flex;
      gap: 16px;
      justify-content: flex-end;
    }
    
    .button {
      width: 50%;
    }
  `

  eventListeners: EventListeners = [
    ['#cancel-button', 'click', () => {}],
    ['#confirm-button', 'click', () => {}],
  ]
}
